import cn from 'classnames';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { Autoplay, FreeMode, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import ButtonNavSwiper from '@/components/ButtonNavSwiper';
import MoreInfo from '@/components/MoreInfo';
import { placeholderImageUrl } from '@/lib/constants';
import { onwheelCustomersData } from './onwheelData';

export default function OnWheelCustomers() {
  const [load, setLoad] = useState<boolean>(false);
  useEffect(() => setLoad(true), []);
  return (
    <section className="desktop:py-16 py-8">
      <h2 className="text-neutral-90 desktop:text-title42 text-title32 desktop:max-w-content desktop:mb-0 desktop:px-8 mx-auto mb-8 px-4 text-center font-bold">
        Các đối tác tin tưởng sử dụng
      </h2>
      {load ? (
        <div className="relative overflow-hidden">
          <div className="max-w-8xl desktop:px-8 desktop:top-1/2 absolute inset-x-auto top-1/3 z-10 mx-auto flex min-w-full -translate-y-1/2 items-center justify-between px-4">
            <ButtonNavSwiper type="left" className="col-span-1" />
            <ButtonNavSwiper type="right" className="col-span-1" />
          </div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay, FreeMode]}
            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={0}
            loop={true}
            navigation={{ prevEl: '.prevEl', nextEl: '.nextEl' }}
            autoplay={{ delay: 3000 }}
            centeredSlides={true}
            roundLengths={true}
            pagination={{ clickable: true }}
          >
            {onwheelCustomersData.map((item, idx) => (
              <SwiperSlide key={idx} className="desktop:py-14 desktop:px-8">
                <div className="desktop:max-w-7xl desktop:grid-cols-2 desktop:rounded-lg shadow-shadow-special mx-auto grid grid-cols-1">
                  <div className="desktop:aspect-[546/478] relative col-span-1 aspect-[343/253] w-full">
                    <Image
                      src={item.imgDesktop}
                      alt={item.imgDesktop}
                      fill
                      priority
                    />
                  </div>

                  <div className=" desktop:px-10 col-span-1 flex flex-col items-start justify-center px-4 py-8">
                    <p className="bg-neutral-10 text-secondary-70 text-caption12 desktop:mb-6 mb-4 rounded-md p-3 font-bold uppercase">
                      {item.title}
                    </p>
                    <h3 className="text-subtitle18 text-neutral-80 mb-2 font-bold">
                      Những dịch vụ mà Onwheel đã cung cấp như:
                    </h3>
                    <ul className="font-body16 text-neutral-80 list-inside list-disc space-y-1 font-medium">
                      {item.services.map((service, idx) => (
                        <li key={idx}>{service}</li>
                      ))}
                    </ul>
                    <div className="my-4">
                      <MoreInfo
                        title="Tìm hiểu thêm"
                        type="secondary"
                        href={item.link}
                        setLocale={false}
                      />
                    </div>
                    <h3 className="text-subtitle18 text-neutral-80 mb-2 font-bold">
                      Các đối tác đã tin tưởng sử dụng
                    </h3>
                    <div className="flex flex-row space-x-4">
                      {item.customersLogo.map((customer, idx) => (
                        <div
                          className={cn('relative h-16', {
                            'aspect-square': customer.type === 'square',
                            'aspect-[21/8]': customer.type === 'rectangle',
                            'aspect-[57/43]': customer.type === 'other',
                          })}
                          key={idx}
                        >
                          <Image
                            src={customer.src || placeholderImageUrl}
                            alt={customer.alt}
                            fill
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div>Load Image</div>
      )}
    </section>
  );
}
